import React from 'react';
import * as containers from '../../containers';
import { Switch, Route } from 'react-router-dom';
import { PageComponentProps } from 'shared/interface/globalInterface';
import RegistrationFormTemplate from '../../components/Form/RegistrationFormTemplate/RegistrationFormTemplate';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';

const Registration: React.FC<PageComponentProps> & PageLayoutParams = ({ match }) => {
  const url = match.url;

  return (
    <RegistrationFormTemplate>
      <Switch>
        <Route path={`${url}/search-firms`}>
          <containers.SearchFirmsContainer />
        </Route>
        <Route path={`${url}/register-firm`}>
          <containers.RegisterFirmContainer />
        </Route>
        <Route path={`${url}/due-diligence`}>
          <containers.DueDiligenceContainer />
        </Route>
        <Route path={`${url}/personal-details`}>
          <containers.PersonalDetailsContainer />
        </Route>
      </Switch>
    </RegistrationFormTemplate>
  );
};

Registration.layout = Layouts.REGISTRATION;

export default Registration;
